/* ==========================================================================
   Tingue header navigation — behaviour
   --------------------------------------------------------------------------
   Load in layout/theme.liquid before </body>:
     <script src="{{ 'tingue-menu.js' | asset_url }}" defer></script>

   All markup is rendered server-side by the Liquid snippets. This file only:
     1. opens / closes the nav dropdowns
     2. switches which subcategory + type group is visible
     3. builds the search index by reading the rendered DOM (nothing to sync)
     4. drives the mobile sliding stack
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var hdr = document.querySelector('[data-tgm]');
    if (!hdr || hdr.dataset.tgmReady) return;
    hdr.dataset.tgmReady = '1';

    var CLOSE_DELAY = 320;           // forgiving enough to cross a gap
    var SPLIT_AT = 11;               // type lists longer than this use 2 columns
    var canHover = window.matchMedia('(hover:hover) and (min-width:901px)').matches;
    var isMobile = function () { return window.matchMedia('(max-width:900px)').matches; };

    /* ---------------------------------------------------------------- *
     * open / close
     * ---------------------------------------------------------------- */
    var groups = [].slice.call(hdr.querySelectorAll('[data-tgm-menu]'));
    var burger = hdr.querySelector('[data-tgm-burger]');
    var catGroup = hdr.querySelector('[data-tgm-menu="category"]');
    var closeTimer = null;
    var current = null;

    function panelOf(g) { return g.querySelector('[data-tgm-panel]'); }
    function triggerOf(g) { return g.querySelector('[data-tgm-trigger]'); }

    function closeAll() {
      groups.forEach(function (g) {
        var t = triggerOf(g);
        if (t) { t.classList.remove('is-active'); t.setAttribute('aria-expanded', 'false'); }
        var p = panelOf(g);
        if (p) p.classList.remove('is-shown');
      });
      document.body.classList.remove('tgm-open', 'tgm-lock');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (cols) cols.setAttribute('data-level', '1');
      if (searchInput) { searchInput.value = ''; applySearch(''); }
      current = null;
    }

    function openGroup(g) {
      clearTimeout(closeTimer);
      if (current === g) return;
      closeAll();
      current = g;
      var t = triggerOf(g);
      if (t) { t.classList.add('is-active'); t.setAttribute('aria-expanded', 'true'); }
      var p = panelOf(g);
      if (p) p.classList.add('is-shown');
      document.body.classList.add('tgm-open');
      if (isMobile()) document.body.classList.add('tgm-lock');
      if (g === catGroup && burger) burger.setAttribute('aria-expanded', 'true');
    }

    /* Track the pointer so we can sanity-check a close.
       `mouseleave` also fires with relatedTarget === null when the element under
       a stationary cursor is hidden or the layout shifts — and the drill-down
       hides groups under the cursor constantly. Closing on those would make the
       menu feel like it dismisses itself, so confirm the pointer really left. */
    var ptr = { x: -1, y: -1 };
    document.addEventListener('mousemove', function (e) {
      ptr.x = e.clientX; ptr.y = e.clientY;
    }, { passive: true });

    // function pointerInside(g) {
    //   if (!g) return false;
    //   return [triggerOf(g), panelOf(g)].some(function (el) {
    //     if (!el) return false;
    //     var r = el.getBoundingClientRect();
    //     return ptr.x >= r.left && ptr.x <= r.right && ptr.y >= r.top && ptr.y <= r.bottom;
    //   });
    // }

    function pointerInside(g) {
      if (!g) return false;
      var el = document.elementFromPoint(ptr.x, ptr.y);
      return !!(el && g.contains(el));
    }

    // function closeSoon() {
    //   clearTimeout(closeTimer);
    //   closeTimer = setTimeout(function () {
    //     if (pointerInside(current)) return;
    //     closeAll();
    //   }, CLOSE_DELAY);
    // }

    function closeSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (!current) return;
        if (pointerInside(current)) return;
        closeAll();
      }, CLOSE_DELAY);
    }

    groups.forEach(function (g) {
      var t = triggerOf(g);
      var p = panelOf(g);
      if (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          current === g ? closeAll() : openGroup(g);
        });
      }
      if (canHover) {
        g.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          openGroup(g);
        });

        /*
        * For the category menu, close based on the actual dropdown panel,
        * not the nav group. The category group uses position:static and
        * therefore does not represent the visible dropdown area.
        */
        if (g === catGroup) {
          if (p) {
            p.addEventListener('mouseenter', function () {
              clearTimeout(closeTimer);
            });

            p.addEventListener('mouseleave', function () {
              closeSoon();
            });
          }
        } else {
          g.addEventListener('mouseleave', closeSoon);

          if (p) {
            p.addEventListener('mouseenter', function () {
              clearTimeout(closeTimer);
            });

            p.addEventListener('mouseleave', closeSoon);
          }
        }
      }


    });

    if (burger && catGroup) {
      burger.addEventListener('click', function () {
        current === catGroup ? closeAll() : openGroup(catGroup);
      });
    }

    var scrim = document.querySelector('[data-tgm-scrim]');
    if (scrim) scrim.addEventListener('click', closeAll);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) {
        var t = triggerOf(current);
        closeAll();
        if (t) t.focus();
      }
    });

    /* ---------------------------------------------------------------- *
     * category drill-down
     * ---------------------------------------------------------------- */
    var cols = hdr.querySelector('[data-tgm-cols]');
    if (!cols) return;

    var c1 = hdr.querySelector('[data-tgm-c1]');
    var c2 = hdr.querySelector('[data-tgm-c2]');
    var c3 = hdr.querySelector('[data-tgm-c3]');
    var t2 = hdr.querySelector('[data-tgm-t2]');
    var m2 = hdr.querySelector('[data-tgm-m2]');
    var t3 = hdr.querySelector('[data-tgm-t3]');
    var m3 = hdr.querySelector('[data-tgm-m3]');
    var crumbCat = hdr.querySelector('[data-tgm-crumb-cat]');
    var crumbSub = hdr.querySelector('[data-tgm-crumb-sub]');

    var i1 = null;
    var i2 = null;

    function g2Of(i) { return c2.querySelector('[data-tgm-g2="' + i + '"]'); }
    function g3Of(i, j) { return c3.querySelector('[data-tgm-g3="' + i + '-' + j + '"]'); }
    var g3Empty = c3.querySelector('[data-tgm-g3="empty"]');

    function setText(el, v) { if (el) el.textContent = v || ''; }

    function markActive(container, attr, value) {
      [].forEach.call(container.querySelectorAll('[' + attr + ']'), function (r) {
        r.classList.toggle('is-active', r.getAttribute(attr) === String(value));
      });
    }

    function showCrumb(el, label) {
      if (!el) return;
      if (label) {
        var slot = el.querySelector('[data-tgm-crumb-text]');
        if (slot) slot.textContent = label;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
      el.classList.remove('is-current');
    }

    function updateCrumb(catLabel, subLabel) {
      showCrumb(crumbCat, catLabel);
      showCrumb(crumbSub, subLabel);
      var last = subLabel ? crumbSub : (catLabel ? crumbCat : null);
      if (last) last.classList.add('is-current');
    }

    function resetLevel3() {
      i2 = null;
      [].forEach.call(c3.querySelectorAll('[data-tgm-g3]'), function (g) { g.hidden = true; });
      if (g3Empty) g3Empty.hidden = false;
      setText(t3, '');
      setText(m3, '');
    }

    function pick1(i, force) {
      if (i1 === i && !force) return;
      i1 = i;
      markActive(c1, 'data-tgm-l1', i);

      [].forEach.call(c2.querySelectorAll('[data-tgm-g2]'), function (g) { g.hidden = true; });
      var g = g2Of(i);
      var hasSubs = false;
      if (g) {
        g.hidden = false;
        g.scrollTop = 0;
        setText(t2, g.dataset.title);
        setText(m2, g.dataset.meta);
        hasSubs = g.dataset.leaf !== 'true';
      }
      c2.scrollTop = 0;
      cols.classList.toggle('is-leaf', !hasSubs);
      resetLevel3();
      updateCrumb(g ? g.dataset.title : '', '');
    }

    function pick2(j) {
      if (i2 === j) return;
      i2 = j;
      var g2 = g2Of(i1);
      if (g2) markActive(g2, 'data-tgm-l2', j);

      [].forEach.call(c3.querySelectorAll('[data-tgm-g3]'), function (g) { g.hidden = true; });
      var g = g3Of(i1, j);
      if (g) {
        g.hidden = false;
        setText(t3, g.dataset.title);
        setText(m3, g.dataset.meta);
      } else if (g3Empty) {
        g3Empty.hidden = false;
      }
      c3.scrollTop = 0;
      updateCrumb(g2 ? g2.dataset.title : '', g ? g.dataset.title : '');
    }

    /* hover previews on desktop, click drills (and advances the mobile stack) */
    if (canHover) {
      c1.addEventListener('mouseover', function (e) {
        var r = e.target.closest('[data-tgm-l1]');
        if (r) pick1(r.getAttribute('data-tgm-l1'));
      });
      c2.addEventListener('mouseover', function (e) {
        var r = e.target.closest('[data-tgm-l2]');
        if (r) pick2(r.getAttribute('data-tgm-l2'));
      });
    }
    c1.addEventListener('click', function (e) {
      var r = e.target.closest('[data-tgm-l1]');
      if (!r || r.tagName === 'A') return;      // leaf links navigate
      pick1(r.getAttribute('data-tgm-l1'));
      cols.setAttribute('data-level', '2');
    });
    c2.addEventListener('click', function (e) {
      var r = e.target.closest('[data-tgm-l2]');
      if (!r || r.tagName === 'A') return;
      pick2(r.getAttribute('data-tgm-l2'));
      cols.setAttribute('data-level', '3');
    });
    [].forEach.call(hdr.querySelectorAll('[data-tgm-back]'), function (b) {
      b.addEventListener('click', function () {
        cols.setAttribute('data-level', b.getAttribute('data-tgm-back'));
      });
    });

    /* long type lists get two text columns; done here so Liquid stays simple */
    [].forEach.call(c3.querySelectorAll('[data-tgm-g3]'), function (g) {
      if (g.querySelectorAll('.tgm-row').length > SPLIT_AT) g.classList.add('tgm-group--split');
    });

    /* ---------------------------------------------------------------- *
     * search — index built from the rendered DOM
     * ---------------------------------------------------------------- */
    var searchInput = hdr.querySelector('[data-tgm-search]');
    var searchClear = hdr.querySelector('[data-tgm-search-clear]');
    var resultsEl = hdr.querySelector('[data-tgm-results]');
    var INDEX = [];

    function labelOf(row) {
      var l = row.querySelector('.tgm-row__lbl');
      return (l ? l.textContent : row.textContent).trim();
    }

    function buildIndex() {
      [].forEach.call(c1.querySelectorAll('[data-tgm-l1]'), function (r1) {
        var i = r1.getAttribute('data-tgm-l1');
        var g2 = g2Of(i);
        var catName = g2 ? g2.dataset.title : labelOf(r1);
        INDEX.push({
          label: labelOf(r1), href: r1.getAttribute('href'), path: [],
          leaf: r1.classList.contains('tgm-row--leaf'), i1: i, i2: null
        });
        if (!g2) return;
        [].forEach.call(g2.querySelectorAll('[data-tgm-l2]'), function (r2) {
          var j = r2.getAttribute('data-tgm-l2');
          var g3 = g3Of(i, j);
          INDEX.push({
            label: labelOf(r2), href: r2.getAttribute('href'), path: [catName],
            leaf: r2.classList.contains('tgm-row--leaf'), i1: i, i2: j
          });
          if (!g3) return;
          [].forEach.call(g3.querySelectorAll('.tgm-row'), function (r3) {
            INDEX.push({
              label: labelOf(r3), href: r3.getAttribute('href'),
              path: [catName, g3.dataset.title], leaf: true, i1: i, i2: j
            });
          });
        });
      });
    }

    function escapeHTML(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function highlight(label, q) {
      var at = label.toLowerCase().indexOf(q);
      if (at < 0) return escapeHTML(label);
      return escapeHTML(label.slice(0, at)) + '<mark>' +
             escapeHTML(label.slice(at, at + q.length)) + '</mark>' +
             escapeHTML(label.slice(at + q.length));
    }

    function applySearch(raw) {
      var q = (raw || '').trim().toLowerCase();
      var on = q.length > 0;
      if (resultsEl) resultsEl.hidden = !on;
      cols.hidden = on;
      if (searchClear) searchClear.hidden = !on;
      if (!on || !resultsEl) return;

      var starts = [], contains = [];
      INDEX.forEach(function (it) {
        var l = it.label.toLowerCase();
        if (l.indexOf(q) === 0) starts.push(it);
        else if (l.indexOf(q) > -1) contains.push(it);
      });
      var hits = starts.concat(contains).slice(0, 60);

      if (!hits.length) {
        resultsEl.innerHTML = '<div class="tgm-results__meta">No category matches ' +
          '\u201c' + escapeHTML(raw) + '\u201d. Try a shorter word.</div>';
        return;
      }

      resultsEl.innerHTML =
        '<div class="tgm-results__meta">' + hits.length + ' match' +
        (hits.length === 1 ? '' : 'es') + ' for \u201c' + escapeHTML(raw) + '\u201d</div>' +
        hits.map(function (it) {
          var tag = it.leaf ? 'Products' : 'Browse';
          return '<a class="tgm-hit" href="' + (it.href || '#') + '"' +
            ' data-tgm-hit-i1="' + it.i1 + '" data-tgm-hit-i2="' + (it.i2 === null ? '' : it.i2) + '"' +
            ' data-tgm-hit-leaf="' + (it.leaf ? '1' : '0') + '">' +
            '<span class="tgm-hit__main">' +
              '<span class="tgm-hit__lbl">' + highlight(it.label, q) + '</span>' +
              (it.path.length ? '<span class="tgm-hit__path">' +
                escapeHTML(it.path.join('  \u203a  ')) + '</span>' : '') +
            '</span>' +
            '<span class="tgm-hit__tag' + (it.leaf ? ' tgm-hit__tag--parts' : '') + '">' +
              tag + '</span></a>';
        }).join('');
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () { applySearch(searchInput.value); });
    }
    if (searchClear) {
      searchClear.addEventListener('click', function () {
        searchInput.value = '';
        applySearch('');
        searchInput.focus();
      });
    }
    if (resultsEl) {
      /* a non-leaf hit drops you into the columns at that spot instead of navigating */
      resultsEl.addEventListener('click', function (e) {
        var hit = e.target.closest('[data-tgm-hit-i1]');
        if (!hit || hit.getAttribute('data-tgm-hit-leaf') === '1') return;
        e.preventDefault();
        searchInput.value = '';
        applySearch('');
        pick1(hit.getAttribute('data-tgm-hit-i1'), true);
        var j = hit.getAttribute('data-tgm-hit-i2');
        if (j) pick2(j);
        var active = c1.querySelector('.is-active');
        if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest' });
      });
    }

    /* ---------------------------------------------------------------- *
     * currency / company-location pickers
     * ---------------------------------------------------------------- */
    [].forEach.call(hdr.querySelectorAll('[data-tgm-pick]'), function (box) {
      box.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-tgm-pick-opt]');
        if (!opt) return;
        [].forEach.call(box.querySelectorAll('[data-tgm-pick-opt]'), function (o) {
          o.classList.remove('is-on');
        });
        opt.classList.add('is-on');
        /* Visual state only. Currency options are real submit buttons inside a
           {% form 'localization' %}, so the browser posts the country_code for
           us — calling form.submit() here would drop that value. */
      });
    });

    /* open on the first department deep enough to fill all three columns */
    buildIndex();
    var first = c1.querySelector('[data-tgm-l1]');
    var preferred = null;
    [].some.call(c1.querySelectorAll('[data-tgm-l1]'), function (r) {
      var g = g2Of(r.getAttribute('data-tgm-l1'));
      if (g && g.dataset.deep === 'true') { preferred = r; return true; }
      return false;
    });
    var start = preferred || first;
    if (start) pick1(start.getAttribute('data-tgm-l1'), true);

    document.addEventListener('DOMContentLoaded', function () {
      const searchToggle = document.getElementById('search-toggle');
      const searchWrapper = document.querySelector('.search-modal-wrapper');
      const closeSearch = document.querySelector('.close-search-box');

      if (searchToggle && searchWrapper) {
        searchToggle.addEventListener('click', function (e) {
          e.preventDefault();

          if (searchWrapper.style.display === 'none' || !searchWrapper.style.display) {
            searchWrapper.style.display = 'flex';
          } else {
            searchWrapper.style.display = 'none';
          }
        });
        closeSearch.addEventListener('click', function (e) {
          e.preventDefault();
          searchWrapper.style.display = 'none';

          setTimeout(function () {
            const clearButton = document.querySelector('.aa-ClearButton');

            if (clearButton) {
              clearButton.click();
            }

            // Clear and blur input
            const searchInput = document.querySelector('.aa-Input');

            if (searchInput) {
              searchInput.value = '';
              searchInput.blur();
            }
          }, 1000);
        });
      }
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
